const faqItems = [
  {
    id: 1,
    q: '密桃视频需要注册登录才能观看吗？',
    a: '不需要。密桃视频目前完全免费开放，无需注册或登录即可直接浏览和观看所有视频内容。我们致力于为用户提供最便捷的观影体验，打开即可观看。',
  },
  {
    id: 2,
    q: '视频播放卡顿或加载慢怎么办？',
    a: '我们内置了智能线路切换功能，播放卡顿时会自动切换到最优线路。你也可以手动调整画质，在网络不佳时选择标清模式获得更流畅的播放体验。',
  },
  {
    id: 3,
    q: '支持哪些设备观看？',
    a: '密桃视频支持电脑、平板和手机等所有主流设备观看。网页端自适应屏幕尺寸，移动端经过专门优化，横竖屏切换流畅，随时随地都能享受观影乐趣。',
  },
  {
    id: 4,
    q: '视频画质能达到什么标准？',
    a: '平台提供从标清到超清多种画质选择，热门内容均支持1080P高清播放。实际画质取决于片源质量和你当前的网络环境，系统会自动推荐最佳画质。',
  },
  {
    id: 5,
    q: '内容多久更新一次？',
    a: '我们与各大视频源保持实时同步，热门电视剧通常播出后几小时内即可观看，综艺节目隔日更新，电影资源会根据网络资源情况持续补充入库。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-question-answer-line"></i>
            <span>疑问解答</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            关于密桃视频的常见问题，快速了解我们的服务
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-primary-500 text-sm font-bold">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}